import { create } from 'zustand';

type State = {
  isFormChanged: boolean;
  isMediaReadyForUpload: boolean;
  uploadingQuestionId: string | null;
  reorderChanged: boolean;
  interviewQuestionsStructureChanged: boolean;
  isProjectCreateButtonDisabled: boolean;
  duplicatedScreeningQuestion: { id: string };
  duplicatedScreeningQuestionAnswer: { id: string };
};

type Action = {
  setIsFormChanged: (change: boolean) => void;
  setIsMediaReadyForUpload: (change: boolean) => void;
  setUploadingQuestionId: (questionId: string | null) => void;
  setReorderChanged: (uploading: boolean) => void;
  setInterviewQuestionsStructureChanged: (changed: boolean) => void;
  setIsProjectCreateButtonDisabled: (uploading: boolean) => void;
  setDuplicatedScreeningQuestion: (question: { id: string }) => void;
  setDuplicatedScreeningQuestionAnswer: (answer: { id: string }) => void;
};

const updateIsProjectCreateButtonDisabled = (
  question: { id: string },
  answer: { id: string },
  set: (state: Partial<State>) => void,
) => {
  const isDisabled = !!(!!question?.id || !!answer?.id);
  set({ isProjectCreateButtonDisabled: isDisabled });
};

const useCreateProjectStore = create<State & Action>((set, get) => ({
  isFormChanged: false,
  setIsFormChanged: (change) => set({ isFormChanged: change }),

  isMediaReadyForUpload: false,
  setIsMediaReadyForUpload: (change) => set({ isMediaReadyForUpload: change }),

  uploadingQuestionId: null,
  setUploadingQuestionId: (questionId) => set({ uploadingQuestionId: questionId }),

  reorderChanged: false,
  setReorderChanged: (reorder) => set({ reorderChanged: reorder }),

  interviewQuestionsStructureChanged: false,
  setInterviewQuestionsStructureChanged: (changed) =>
    set({ interviewQuestionsStructureChanged: changed }),

  isProjectCreateButtonDisabled: false,
  setIsProjectCreateButtonDisabled: (disabled) => set({ isProjectCreateButtonDisabled: disabled }),

  duplicatedScreeningQuestion: { id: '' },
  setDuplicatedScreeningQuestion: (question) => {
    set({ duplicatedScreeningQuestion: question });
    updateIsProjectCreateButtonDisabled(question, get().duplicatedScreeningQuestionAnswer, set);
  },

  duplicatedScreeningQuestionAnswer: { id: '' },
  setDuplicatedScreeningQuestionAnswer: (answer) => {
    set({ duplicatedScreeningQuestionAnswer: answer });
    updateIsProjectCreateButtonDisabled(get().duplicatedScreeningQuestion, answer, set);
  },
}));

export default useCreateProjectStore;
